<template>
    <div class="fzg-news-pc">
      <div class="fzg-banner">
        <fzg-menu/>
        <div class="sologan"></div>
      </div>

      <div class="news-deal-pc">
        <img class="main-title" src="../../assets/img2/pc/news/title_trans.png" alt="">
        <div class="deal-list">

          <a class="deal-item" v-for="item in dealList" :href="item.link" target="_blank" >
            <div class="logo-area">
              <img class="logo" :src="item.banner">
            </div>
            <div class="title">{{ item.title }}</div>
            <div class="right-plus"> <img class="icon-plus" src="../../assets/img2/pc/news/icon-add.png"> </div>
          </a>

          <div v-if="false" class="deal-item" v-for="i in 10" >
            <div class="logo-area">
              <img class="logo" src="../../assets/img2/pc/fa/fa_data_1.png">
            </div>
            <div class="title"> 凡卓资本成功帮助超过 600家创业公司完成融资 </div>
            <div class="right-plus">
              <img class="icon-plus" src="../../assets/img2/pc/news/icon-add.png">
            </div>
          </div>
        </div>
      </div>


      <div class="fzg-recent-activity">
        <a name="activity"></a>
        <img class="activity-title" src="../../assets/img2/pc/news/title_activity.png" alt="">
        <div class="fzg-activity-wrap">
          <div class="activity-left">
            <!-- <img src="../../assets/img2/pc/fa/fa-research-bg-1.jpg" alt=""> -->
            <a :href="firstActivityNews.link" target="_blank">
              <img :src="firstActivityNews.banner" alt="">
              <div class="l-title-area">
                <div class="l-date">{{firstActivityNews.date}} </div>
                <div class="l-title">{{firstActivityNews.title}}</div>
              </div>
            </a>
          </div>
          <div class="activity-right">

            <div class="right-item"
              v-for="(item,index) in activityNewsList"
              v-if="index > 0 && index < 4">
              <a :href="item.link" target="_blank">
                <div class="r-item-date">{{ item.date }} </div>
                <div class="r-item-title">{{ item.title.substr(0,40) }}</div>
                <div class="r-item-content">{{ item.brief.length > 50 ? item.brief.substr(0,50) + '...' : item.brief }}</div>
              </a>
            </div>

          </div>
        </div>
      </div>

      <div class="fzg-activity">
        <img class="title-activity" src="../../assets/img2/pc/news/title_news.png" alt="">
        <div class="activity-area">

          <div class="act-item" v-for="item in groupNewsList">
            <a :href="item.link" target="_blank">
              <div class="act-icon">
                <img :src="item.banner">
              </div>
              <div class="right-content">
                <div class="act-title">{{ item.title }}</div>
                <div class="act-content">{{ item.content.length > 40 ? item.content.substr(0, 40) + '...' : item.content }}</div>
              </div>
            </a>
          </div>

          <div class="act-item" v-if="false" v-for="item in 10 ">
            <img class="act-icon" src="../../assets/img2/pc/fzg-bussiness-icon1.jpg" alt="">
            <div class="right-content">
              <div class="act-title">「蔚领时代」完成4000万美元B2轮融资，凡卓资本担任财务顾问</div>
              <div class="act-content">国内第一批创投服务机构，拥有包含小饭桌ROADSHOW、、社群等明星产品</div>
            </div>
          </div>

        </div>

        <div class="page-num">
          <span v-for="page in groupNewsPageData.total_page"
            :class="{'active': page == currentNewsPage}"
            @click="changeNewsPage(page)"> {{ page }}</span>
        </div>

      </div>
    </div>
</template>

<script>

import util from '../../assets/js/util'
import FzgMenu from '../common/FzgMenu.vue'

export default{
    components:{
      FzgMenu
    },
    props:[''],
    data(){
      return {
        activeCompany: 1,
        dealList: [],
        activityNewsList: [],
        firstActivityNews: {},
        groupNewsList: [],
        currentNewsPage: 1,
        groupNewsPageData: {},
      }
    },
    methods:{
      initView() { },
      getDealList() {
        var self = this
        util.resource({
            url: '/api/fzg/deal_news/',
            method: 'get',
            data: {
              p: 1,
              n: 200,
            },
            success (res) {
              if (res.code == 200) {
                self.dealList = res.data.list
              }
            }
        })
      },
      getActivityNewsList() {
        var self = this
        util.resource({
            url: '/api/fzg/activity_news/',
            method: 'get',
            data: {
              p: 1,
              n: 100,
            },
            success (res) {
              if (res.code == 200) {
                self.activityNewsList = res.data.list
                if (self.activityNewsList.length > 0) {
                  self.firstActivityNews = self.activityNewsList[0]
                }
              }
            }
        })
      },
      getGroupNewsList() {
        var self = this
        util.resource({
            url: '/api/fzg/group_news/',
            method: 'get',
            data: {
              p: self.currentNewsPage,
              n: 4,
            },
            success (res) {
              if (res.code == 200) {
                self.groupNewsList = res.data.list
                self.groupNewsPageData = res.data.page
              }
            }
        })
      },
      changeNewsPage(page) {
        this.currentNewsPage = page
        this.getGroupNewsList()
      }
    },
    mounted(){
      this.getDealList()
      this.getActivityNewsList()
      this.getGroupNewsList()
    },
    watch: {
    },

}
</script>

<style lang="scss" scoped>
.fzg-news-pc {
  .fzg-banner {
    // border: 1px solid red;
    // background: url(../../assets/img2/pc/news/banner.jpg) no-repeat;
    // background: url(https://static-image.xfz.cn/1686266438405/news-bn.png) no-repeat;
    background: url(https://static-image.xfz.cn/1687734784761/news_banner.png) no-repeat;
    background-size: auto;
    background-position: center;
    background-color: #8799b1;
    height: 340px;
    position: relative;
    .sologan {
      // border: 1px solid red;
      width: 100%;
      height: 50px;
      background-image: url(../../assets/img2/pc/news/sologan.png);
      background-repeat: no-repeat;
      background-size: auto 100%;
      background-position: center;
      // color: white;
      margin: 80px auto 0;
    }
  }

  .news-deal-pc {
    border: 1px solid #ffffffff;
    display: block;
    margin: 50px auto 80px;
    position: relative;
    .main-title {
      width: 130px;
      position: absolute;
      left: 50%;
      right: 0;
      top: 0;
      margin-left: -550px;
    }
    .deal-list {
      // border: 1px solid #ccc;
      margin: 100px auto 80px;
      width: 1100px;
      height: 630px;
      overflow-y: scroll;
      padding-right: 35px;
      &::-webkit-scrollbar {
        width: 6px;
        background-color: #ffffffff;
      }

      /* 改变滚动条的滑块颜色 */
      &::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: #d7ad78;
      }

      .deal-item {
        // background-color: #f5f5f5;
        text-align: left;
        width: 100%;
        height: 100px;
        cursor: pointer;
        border-bottom: 1px solid #ccc;
        display: table;

        .logo-area {
          // border: 1px solid red;
          display: table-cell;
          vertical-align:middle;
          width: 150px;
          height: 80px;
          // margin: 20px 0;
          overflow: hidden;
          .logo {
            // border: 1px solid gray;
            object-fit: cover;
            margin: 5px 30px 0;
            width: 150px;
            height: 80px;
          }
        }
        .title{
          // border: 1px solid red;
          display:table-cell;
          vertical-align:middle;
          font-size: 15px;
          color: #444444;
          line-height: 1.5;
          width: 800px;
          overflow:hidden;
          padding-left: 20px;
          text-overflow: ellipsis;
          padding: 40px 0;
          &:hover {
            color: #d7ad78;
          }
        }
        .right-plus {
          display: table-cell;
          vertical-align: middle;
          // border: 1px solid #ccc;
          color: gray;
          .icon-plus {
            width: 26px;
            height: 26px;
            margin-top: 6px;
            margin-right: 30px;
            margin-left: 30px;
          }
        }
        &:first-child {
          border-top: 1px solid #ccc;
        }
      }
    }
  }

  .fzg-recent-activity{
    // border: 1px solid blue;
    height: 850px;
    margin: 0 auto;
    position: relative;
    background: #f8f9fe;
    .activity-title {
      // border:  1px solid #ce262f;
      width: 160px;
      position: absolute;
      left: 50%;
      right: 0;
      top: 55px;
      margin-left: 380px;
    }
    .fzg-activity-wrap {
      // border: 1px solid blue;
      width: 1100px;
      height: 600px;
      position: absolute;
      left: 50%;
      right: 0;
      top: 180px;
      text-align: left;
      margin-left: -550px;
      color: #575758;
      font-size: 16px;
      .activity-left {
        // border: 1px solid red;
        display: inline-block;
        width: 680px;
        height: 560px;
        background: #ededed;
        // margin-right: 5px;
        overflow: hidden;
        position: relative;
        img {
          width: 100%;
          height: auto;
        }
        .l-title-area {
            // border: 1px solid red;
            background-color: #2d333a;
            position: absolute;
            width: 100%;
            left: 0;
            bottom: 0;
            text-align: left;
          .l-date {
            margin-top: 20px;
            font-size: 19px;
            padding: 10px 25px;
            color: white;
            font-weight: bold;
          }
          .l-title {
            font-size: 15px;
            padding: 15px 25px;
            color: white;
            margin-bottom: 30px;
          }
        }
      }
      .activity-right {
        // border: 1px solid red;
        vertical-align: top;
        display: inline-block;
        margin-left: -5px;
        // width: 330px;
        min-height: 300px;
        .right-item {
          width: 415px;
          height: 186px;
          background: white;
          position: relative;
          overflow: hidden;
          padding: 15px;
          margin-bottom: 2px;
          img {
            width: auto;
            height: 100%;
            overflow: hidden;
          }
          .r-item-date {
            font-size: 20px;
            font-weight: bold;
            color: #d7ad78;
            margin-top: 10px;
          }
          .r-item-title {
            // border: 1px solid red;
            text-align: left;
            color: #444444;
            font-size: 18px;
            margin-top: 15px;
          }
          .r-item-content {
            // border: 1px solid red;
            text-align: left;
            color: #878787;
            font-size: 13px;
            margin-top: 15px;
          }
          &:hover {
            .r-item-title{
              color: #d7ad78;
            }
          }
        }
      }
    }
  }

  .fzg-activity{
    position: relative;
    height: 700px;
    overflow: auto;
    // border: 1px solid green;
	  // background-color: #f5f2ef;
    .title-activity {
      // border: 1px solid #ce262f;
      width: 160px;
      position: absolute;
      left: 50%;
      right: 0;
      top: 50px;
      margin-left: -540px;
    }
    .activity-area {
      // border: 1px solid green;
      width: 1100px;
      margin: 120px auto 10px;
      height: 400px;
      display: flex;
      flex-flow: row wrap;
      // justify-content: space-around;
      justify-content: flex-start;
      .act-item {
        // border: 1px solid #ccc;
        width: 520px;
        height: 140px;
        background: #f7f7f7;
        margin-top: 50px;
        margin: 50px 12px 0px;
        .act-icon {
          // border: 1px solid green;
          vertical-align: top;
          width: 200px;
          height: 140px;
          overflow: hidden;
          display: inline-block;
          // margin: 0px auto 0;
          padding: 2px;
          text-align: center;
          position: relative;
          img {
            // border: 1px solid green;
            display: block;
            width: 200px;
            height: 140px;
            position: absolute;
            top:-50%;
            left: 0;
            right: 0;
            margin-top: 70px;
            object-fit: contain;
          }
        }
        .right-content {
          // border: 1px solid #ccc;
          text-align: left;
          vertical-align: top;
          width: 310px;
          height: 150px;
          display: inline-block;
          padding: 10px;
          overflow: hidden;
          max-height: 120px;
          // text-overflow: ellipsis;
          // text-overflow: hidden;
          &:hover {
            cursor: pointer;
            color: #d7ad78;
          }
          .act-title {
            // border: 1px solid red;
            font-size: 16px;
            font-weight: bold;
            margin-top: 12px;
          }
          .act-content {
            font-size: 14px;
            margin-top: 15px;
            color: #444444;
            line-height: 1.4;
          }
        }
      }
    }
    .page-num {
      // border: 1px solid red;
      width: 1000px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      margin: 0 auto;
      span {
        cursor: pointer;
        padding: 5px;
      }
      .active {
        color: #d7ad78;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// FzgNewsPc.vue?e60946c2